import { API } from 'aws-amplify';

export default {
    fetchParticipationsList(limit, nextToken) {
        API._graphqlApi._options.aws_appsync_graphqlEndpoint = API._options.API.endpoints[1].endpoint;

        const query = `query listMyParticipations($limit: Int, $nextToken: String) {
            listMyParticipations(limit: $limit, nextToken: $nextToken) {
                data {
                    id
                    assetId
                    saleId
                    agentId
                    status
                    asset {
                        kind
                        address {
                            address
                            city
                            state
                            zip
                        }
                        images {
                            mainImage
                        }
                    }
                    bid {
                        id
                        bidValue
                        status
                        kind
                    }
                    sale {
                        id
                        kind
                        englishAuction {
                            bidIncrement
                            endDate
                            startDate
                            startingPrice
                            currentBidID
                            currentBidValue
                        }
                    }
                }
                count
                nextToken
            }
        }`;

        return API.graphql({
            query,
            variables: {
                limit,
                nextToken,
            },
        });
    },
};
